import {
  CHANGE_PASSWORD,
  FETCH_CHALLENGE_ACCEPT_LIST,
  FETCH_CHALLENGE_HISTORY_LIST,
  FETCH_CHALLENGE_SEND_LIST,
  FETCH_DASHBOARD_DETAILS,
  FETCH_LEADERBOARD_DETAILS,
  GET_ALL_INITIAL_DASHBOARD_DATA,
  SAVE_ACCEPT_CHALLENGE_REQUEST_DATA,
  UPDATE_CHALLENGE_ACCEPT_LIST,
  UPDATE_CHALLENGE_HISTORY_LIST,
  UPDATE_CHALLENGE_SEND_LIST,
  UPDATE_DASHBOAD_DETAILS,
  UPDATE_LEADERBOARD_DETAILS,
} from './ActionTypes';

export const dashboardTestResultFetch = (params, errorSnackbar = () => {
}) => {
  return {
    type: FETCH_DASHBOARD_DETAILS,
    params: params,
    errorSnackbar,
  };
};

export const updateDashBoardTestResult = (data) => {
  return {
    type: UPDATE_DASHBOAD_DETAILS,
    data: data,
  };
};

export const getAllInitialDashboardData = (params, callback) => {
  return {
    type: GET_ALL_INITIAL_DASHBOARD_DATA,
    params,
    callback,
  };
};

export const fetchChallengeList = (params, callback) => {
  return {
    type: FETCH_CHALLENGE_SEND_LIST,
    params: params,
    callback,
  };
};

export const updateChallengeList = (data, callback) => {
  return {
    type: UPDATE_CHALLENGE_SEND_LIST,
    data: data,
    callback,
  };
};

export const fetchChallengeAcceptList = (params, callback) => {
  return {
    type: FETCH_CHALLENGE_ACCEPT_LIST,
    params: params,
    callback,
  };
};

export const updateChallengeAcceptList = (data, callback = () => {
}) => {
  return {
    type: UPDATE_CHALLENGE_ACCEPT_LIST,
    data: data,
    callback,
  };
};

export const fetchChallengeHistoryList = (params, callback = () => {
}) => {
  return {
    type: FETCH_CHALLENGE_HISTORY_LIST,
    params: params,
    callback,
  };
};

export const updateChallengeHistoryList = (data, callback) => {
  return {
    type: UPDATE_CHALLENGE_HISTORY_LIST,
    data: data,
    callback,
  };
};

export const fetchLeaderboardDetails = (params, callback) => {
  return {
    type: FETCH_LEADERBOARD_DETAILS,
    params: params,
    callback,
  };
};

export const updateLeaderBoardDetails = data => {
  return {
    type: UPDATE_LEADERBOARD_DETAILS,
    data: data,
  };
};

export const changePassword = (changePasswordData, success, openSnackbar) => {
  return {
    type: CHANGE_PASSWORD,
    changePasswordData: changePasswordData,
    success,
    openSnackbar,
  };
};

export const save_accepted_challenge_data = (params) => {
  return {
    type: SAVE_ACCEPT_CHALLENGE_REQUEST_DATA,
    params: params,
  };
};
